export function Create(organizationID: number): string {
	return `/v1/organizations/${organizationID}/identity-providers`;
}

export function Delete(organizationID: number, identityProviderID: number): string {
	return `/v1/organizations/${organizationID}/identity-providers/${identityProviderID}`;
}

export function Index(organizationID: number): string {
	return `/v1/organizations/${organizationID}/identity-providers`;
}

export function IndexMapping(organizationID: number, identityProviderID: number): string {
	return `/v1/organizations/${organizationID}/identity-providers/${identityProviderID}/mapping`;
}

export function PortalSSO(organizationID: number, identityProviderID: number): string {
	return `/v1/organizations/${organizationID}/identity-providers/${identityProviderID}/portal-sso`;
}

export function PortalSync(organizationID: number, identityProviderID: number): string {
	return `/v1/organizations/${organizationID}/identity-providers/${identityProviderID}/portal-sync`;
}

export function Show(organizationID: number, identityProviderID: number): string {
	return `/v1/organizations/${organizationID}/identity-providers/${identityProviderID}`;
}

export function UpdateMapping(organizationID: number, identityProviderID: number): string {
	return `/v1/organizations/${organizationID}/identity-providers/${identityProviderID}/mapping`;
}

export function UpdateSSO(organizationID: number, identityProviderID: number): string {
	return `/v1/organizations/${organizationID}/identity-providers/${identityProviderID}/sso`;
}

export function UpdateSync(organizationID: number, identityProviderID: number): string {
	return `/v1/organizations/${organizationID}/identity-providers/${identityProviderID}/sync`;
}

